// import React from 'react'

import ExtensionIcon from '@mui/icons-material/Extension'

// import { ComponentWithSubheader } from 'dash/shared'
import { ServiceEdit } from './edit'
import { ServiceList } from './list'

export default class Service {
  static Edit = ServiceEdit
  static List = ServiceList
  static Icon = ExtensionIcon
}
